import styled from 'styled-components';
import {Select, Space} from 'antd';
import Search from '../../../Search';

const StyledTableFilters = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
  overflow-x: auto;

  .ant-btn {

    .ant-wave {
      display: none !important;
    }

    &.ant-btn-primary {
      .ant-btn-icon {
        svg {
          height: 16px;
          width: 16px;
          path {
            stroke: ${props => props.theme.colors.primary_1};
          }
        }
      }
    }
  }
`;

const StyledTableFiltersSearch = styled(Search)`
  width: 168px;
  height: 40px;
`;

const StyledTableFiltersElements = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
`;

const StyledTableFiltersElementsSpace = styled(Space)`
  width: 100%;
  overflow-x: auto;
  & > .ant-space-item {
    display: flex;
    align-items: center;
    justify-content: center;
    &:not(:first-of-type) {
      max-width: 210px;
      width: 100%;
    }
    &:nth-of-type(2) {
      max-width: 155px;
    }
    &:last-of-type {
      margin-left: unset;
      margin-right: 8px;
    }
  }

  .ant-picker {
    height: 40px;
  }

  .ant-select {
    display: flex;
    align-items: center;
    width: 100%;
  }
`;

const StyledTableFiltersSelect = styled(Select)`
  min-width: 140px;

  &.ant-select-lg {
    .ant-select-selector {
      &::after {
        line-height: 30px;
      }
    }
  }
`;

export {
  StyledTableFilters,
  StyledTableFiltersSearch,
  StyledTableFiltersElements,
  StyledTableFiltersElementsSpace,
  StyledTableFiltersSelect,
};
